import React from "react";
import styles from "./Assessment2Shell.module.css";
import quiz from "../../../json/Quiz.json";

const cfg = quiz.assessment2;

/* ------------------------------------------------------------------
   Shared chrome for every Assessment 2 step: branded header with a
   centred segmented step bar + label, a left section rail, the step
   content on the right, and a Back / Continue (or Submit) footer.
   Each step passes its own `rail` and `children`.
   ------------------------------------------------------------------ */
const Assessment2Shell = ({
  stepIndex = 0,
  totalSteps = cfg.totalSteps || 4,
  stepLabel,
  allComplete = false,
  rail,
  railFilled = false,
  children,
  onBack,
  onNext,
  backLabel = cfg.backLabel || "Back",
  nextLabel = cfg.continueLabel || "Continue",
  nextDisabled = false,
  footer,
  stackFooter = false,
  hideHeader = false,
  hideFooter = false,
  cornerAction,
}) => (
  <div className={styles.shell}>
    {cornerAction && <div className={styles.shellCorner}>{cornerAction}</div>}

    {/* ---- Centred segmented step bar ---- */}
    {!hideHeader && (
      <header className={styles.header}>
        <div className={styles.progress}>
          <div className={styles.segBar} aria-hidden="true">
            {Array.from({ length: totalSteps }).map((_, i) => (
              <span
                key={i}
                className={`${styles.seg} ${allComplete || i <= stepIndex ? styles.segOn : ""}`}
              />
            ))}
          </div>
          {stepLabel && <span className={styles.stepLabel}>{stepLabel}</span>}
        </div>
      </header>
    )}

    <div className={styles.body}>
      <aside className={`${styles.rail} ${railFilled ? styles.railFilled : ""}`}>{rail}</aside>
      <div className={styles.main}>{children}</div>
    </div>

    {/* ---- Footer (custom override, or default Back / Next) ---- */}
    {!hideFooter && (
      <footer className={`${styles.footer} ${stackFooter ? styles.footerStacked : ""}`} data-a2-footer="true">
        {footer || (
          <>
            <button type="button" className={`${styles.navBtn} ${styles.navBack}`} onClick={onBack}>
              {backLabel}
            </button>
            <button
              type="button"
              className={`${styles.navBtn} ${styles.navNext}`}
              onClick={onNext}
              disabled={nextDisabled}
            >
              {nextLabel}
            </button>
          </>
        )}
      </footer>
    )}
  </div>
);

/* Decorative optical lens illustration used in the filled rails. */
export const RailLens = () => (
  <span className={styles.railLens} aria-hidden="true">
    <i className={styles.lensRing} />
    <i className={styles.lensDots} />
    <i className={styles.lensHill} />
  </span>
);

export default Assessment2Shell;
